import { SaleOrderMergeDataset } from '../../datasets/sale.order.merge.dataset';
import { FakeAccountContactMergeData } from '../data/fake.account.contact.merge.data';
import { FakeAccountMergeData } from '../data/fake.account.merge.data';
import { FakeBasicSiteMergeData } from '../data/fake.basic.site.merge.data';
import { FakeCompanyMergeData } from '../data/fake.company.merge.data';
import { FakeInvoiceAccountMergeData } from '../data/fake.invoice.account.merge.data';
import { FakeSaleOrderItemsMergeData } from '../data/fake.sale.order.items.merge.data';
import { FakeSaleOrderMergeData } from '../data/fake.sale.order.merge.data';

export class FakeSaleOrderMergeDataset extends SaleOrderMergeDataset {
    constructor(baseUrl: string = '') {
        super();

        this.saleOrder = new FakeSaleOrderMergeData();
        this.billingCompany = new FakeCompanyMergeData(baseUrl);
        this.customer = new FakeAccountMergeData();
        this.customerContact = new FakeAccountContactMergeData();
        this.saleOrderJobSite = new FakeBasicSiteMergeData();
        this.saleOrderItem = new FakeSaleOrderItemsMergeData();
    }
}

